import React, { useEffect, useState } from "react";
import { Icon } from "semantic-ui-react";
import { CSSTransitionGroup } from "react-transition-group";
import "./department.css";

import { useForm, Controller } from "react-hook-form";
import { Message } from "semantic-ui-react";
import Selection from '../Team/Selection'
import CreateEdit from './CreateEdit'
import Invite from './Invite'
import UserList from '../Team/userList'

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  UPDATE_EMPLOYEE,
  LOAD_EMPLOYEES,
} from "constants/actions";


import {
  Text,
  SubText,
  Hide,
  TeamContainer,
  InvitedContainer,
  Button
} from "../styled-list";


const DepartmentCard = (props) => {
const dispatch = useDispatch();
  const [visible, setVisible] = React.useState(false);
  const [leaderSent, setLeaderSent] = React.useState(false);
  const [invite,setInvite] = React.useState(false)

  const [invited, setInvited] = React.useState([]);


  React.useEffect(() => {
  	if(props.department?.id){
  		dispatch({
      type: LOAD_EMPLOYEES,
      payload: {params: props.department? `&department=${props.department.id}` : null}
    });
  	}
   
  }, [dispatch, props.department]);

  const { get_employees } = useSelector(
    (state) => ({
      get_employees: state.employees,
    }),
    shallowEqual
  );

  React.useEffect(() => {
    if (get_employees?.employees) {
      setInvited(get_employees.employees);
      if(get_employees.employees.length){
      	console.log(get_employees.employees.length)
      	props.complete()
      }
      
    }
  }, [get_employees]);


  return (
    <TeamContainer type={props.type}>
    	<Icon name="arrow left" size={"large"} style={{ color: "#4a4a4a",cursor:"pointer",marginLeft:-40,marginBottom:-50 }} onClick={()=>props.back()}/>
     	<CreateEdit visible={visible} setVisible={(val)=>setVisible(val)} setDepartment={(id)=>props.setDepartment(id)} department={props.department}/>

      <Hide visible={visible}>
        <SubText>{leaderSent ? "Department Leader" : "Add Department Leader"}</SubText>
        <Invite role="Department Lead" role_id={3} department_id={props.department?props.department.id:false} send={()=>setLeaderSent(true)}/>
        <UserList invited={invited.filter(i=>i.role==3&&i.department==props.department.id)}/>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginTop: 40,
          }}
        >
          <Selection
            color={"#6a00ff"}
            selected={
              invite ? "linear-gradient(260deg, #6a00ff, #6a00ff)" : false
            }
            onClick={() => setInvite(!invite)}
          />
          <Text>Have leader create the department teams?</Text>
        </div>
      </Hide>

    {props.department?.id? <Button onClick={() => props.change(4)} style={{ marginTop: 300 }}>
          Next
        </Button> :""}
    </TeamContainer>
  );
};


export default DepartmentCard